// Commercial pricing math for DentalCAD Connect.
// IMPORTANT (per product spec):
//  - When the LAB offers a price (offeredPrice / accept): commission is a % OF THE LAB PRICE.
//      designerNet = labPrice * (1 - rate);  commission = labPrice * rate
//  - When the DESIGNER states a desired NET (counter offer): commission is a % OF THE NET, added on top.
//      labPrice = net * (1 + rate);          commission = net * rate
// The designer always thinks in NET; the lab always sees what they PAY.

export const DEFAULT_COMMISSION_RATE = 0.15;

export const round2 = (n) => Math.round((Number(n) || 0) * 100) / 100;

// Lab offered a price -> derive the designer net + commission.
export function fromLabPrice(labPrice, rate = DEFAULT_COMMISSION_RATE) {
  const lp = round2(labPrice);
  const commissionAmount = round2(lp * rate);
  return { labPrice: lp, commissionRate: rate, commissionAmount, designerNet: round2(lp - commissionAmount) };
}

// Designer wants a net amount -> derive what the lab pays + commission.
export function fromDesiredNet(net, rate = DEFAULT_COMMISSION_RATE) {
  const dn = round2(net);
  const commissionAmount = round2(dn * rate);
  return { designerNet: dn, commissionRate: rate, commissionAmount, labPrice: round2(dn + commissionAmount) };
}

export const fmtUSD = (n) =>
  `USD ${Number(n || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

// Backward-compatible read of a case's published price (offeredPrice, else legacy budget).
export function caseOfferedPrice(caseItem) {
  const v = caseItem?.offeredPrice ?? caseItem?.budget;
  const n = Number(v);
  return Number.isFinite(n) && n > 0 ? n : 0;
}
